import { useState, useEffect } from 'react'

import { Grid, Typography, Tab, Tabs, Autocomplete, TextField, Button, Dialog, DialogTitle, DialogContentText, DialogContent, DialogActions, Popper, Grow, CircularProgress,styled } from "@mui/material"
import { withStyles } from '@material-ui/core/styles'

import styles from './whatsappStyle'

import { Snackbar, SnackbarContent} from '@material-ui/core'
import FileOpenIcon from '@mui/icons-material/FileOpen';
import * as XLSX from "xlsx";

import { httpRequest } from '../../../../ui-utils/api'
import { backendHosts, apiUrl } from '../../../../ui-utils/apiConfig'

{/*full file added by dev-Ayush 03/12/2024 , whatsapp service */}
const WhatsApp = ({ classes }) => {

    const VisuallyHiddenInput = styled("input")({
        clip: "rect(0 0 0 0)",
        clipPath: "inset(50%)",
        height: 1,
        overflow: "hidden",
        position: "absolute",
        bottom: 0,
        left: 0,
        whiteSpace: "nowrap",
        width: 0.5,
      });

    const [mobile, setMobile] = useState("")
    const [dialog, setDialog] = useState(false)
    const [dialogContent, setDialogContent] = useState({
        title: "",
        body: ""
    })
    const [others, setOthers] = useState([])
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [template, setTemplate] = useState([])
    const [testing, setTesting] = useState(false)
    const [contacts, setContacts] = useState(null)
    const [loading, setLoading] = useState(false)
    const [phoneList, setPhoneList] = useState([])
    const [selectedContacts, setSelectedContacts] = useState(null)
    const [err, setErr] = useState(false)
    const [errMsg, setErrMsg] = useState({msg : "" , color : ""})
    const [fileName , setFileName] = useState("")
    const [fileData , setFileData] = useState([])
    const [topStocks , setTopStocks] = useState(false)

    const getData = async (e) => {

        const file = e.target.files[0];
        if (file.name.includes(".xls") || file.name.includes(".xlsx")) {
            const data = await file.arrayBuffer();
            const workbook = XLSX.read(data);
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const jsonData = XLSX.utils.sheet_to_json(worksheet, {
                header: 1,
                range: 0,
            });

            if (!jsonData[0][0]) {
                return alert("please enter title of the file")
            }

            setFileName(e.target.files[0]?.name)
            setFileData(jsonData?.slice(0,13))
            console.log(jsonData, "jsondata")
        } else {
            alert("please upload an excel file")
            setFileName("")
        }
    }

    const contactsList = contacts && Object.entries(contacts)?.filter(ele => ele[1] !== 0).map(ele => {
        if (ele[0] == "Franchisee") {
            return { label: `${ele[0]}`, value: ele[0] }
        }
        if (ele[0] == "state") {
            return { label: `${ele[0]}`, value: ele[0] }
        }
        else {
            return { label: `${ele[0]} - ${ele[1]}`, value: ele[0] }
        }
    })

    const franchiseeList = contacts && Object.entries(contacts.Franchisee)?.filter(ele => ele[1] !== 0).map((ele, i) => {
        return { id: i, label: `${ele[0]} - ${ele[1]}`, value: ele[0] }
    })

    const StateList = contacts && Object.entries(contacts.state)?.filter(ele => ele[1] !== 0).map((ele, i) => {
        return { id: i, label: `${ele[0]} - ${ele[1]}`, value: ele[0] }
    })


    const handleReset = () => {
        setTesting(false)
        setSelectedContacts(null)
        setOthers([])
    }

    const handleTesting = () => {
        setDialogContent({ ...dialogContent, title: "Please Confirm your mobile number", body: `A whatsapp message will be sent to +91 ${mobile}` })
        setDialog(true)
    }

    const handleSend = async () => {
        setDialog(true)
        setDialogContent({ ...dialogContent, title: "Fetching Contacts....", body: `` })
        setLoading(true)

        let payload = {
            type: selectedContacts?.value == "state" ? "State" : selectedContacts?.value
        }

        if (selectedContacts?.value == "Franchisee") {
            payload.franchisee_codes = others?.map(ele => {
                if(ele.value == "No Refcode"){
                    return "null"
                }else{
                    return ele.value
                }
            })
        }

        if (selectedContacts?.value == "state") {
            payload.state_list = others?.map(ele => {
                if(ele.value == "Unknown State"){
                    return "null"
                }else{
                    return ele.value
                }
            })
        }

        try {
            const phoneList = await httpRequest({
                endPoint: `${backendHosts.ADMIN_REPORT}${apiUrl.whatsappList}`,
                method: "post",
                instance: "instanceOne",
                requestBody: payload
            })

            console.log(phoneList, "phoneList")

            if (phoneList.phone_list) {
                setPhoneList(phoneList?.phone_list)
                setLoading(false)
                setDialogContent({ ...dialogContent, title: "Please Confirm", body: `This message will be sent to ${phoneList?.count} contacts` })
            }

        } catch (e) {
            console.log(e , "erorr")
            setErr(true)
            setErrMsg({msg : "Error Occured" , color : "#F74542"})
        }


    }

    const handleSubmit = async (type) => {

        setDialog(false)
        setTesting(true)
        let payload = {}

        if (type == "send") {
            payload = {
                code: selectedTemplate?.label,
                contacts: phoneList,
            }
        } else {

            payload = {
                code: selectedTemplate?.label,
                contacts: [mobile]
            }
        }

        let url = apiUrl.marketing

        if(selectedTemplate?.label?.includes("portfolio")){
            url = apiUrl.portfolio
        }

        if(topStocks){
            url = apiUrl.dailyStockUpdate
            payload.data = fileData
        }

        try {
            const result = await httpRequest({
                endPoint: `${backendHosts.WHATSAPP}${url}`,
                method: "post",
                instance: "instanceOne",
                requestBody: payload
            })

            if (result.status == 200) {
                setTesting(true)
                setErr(true)
                setErrMsg({msg : "Success" , color : "#50D24A"})
                setOthers([])
                setSelectedContacts(null)
            }
            else {
                setErr(true)
                setErrMsg({msg : "Error Occured" , color : "#F74542"})
            }

        } catch (e) {
            console.log(e , "erorr")
            setErr(true)
            setErrMsg({msg : "Error Occured" , color : "#F74542"})
        }

        console.log(payload, "payload")
    }

    const handleTemplateChange = (event, newValue) => {
        setSelectedTemplate(newValue);
        console.log(newValue)
        if(newValue?.label?.includes("topgainers") || newValue?.label?.includes("toplosers") || newValue?.label?.includes("topturnover")){
            setTopStocks(true)
        }else{
            if(topStocks){
                setTopStocks(false)
                setFileName("")
                setFileData([])
            }
        }
    };

    const handleMobileChange = (event, newValue) => {
        setMobile(event.target.value);
    };

    const handleOthersChange = (event, newValue) => {

        const unique = newValue?.filter((value, index, self) =>
            index === self.findIndex((t) => t.id === value.id)
        );
        setOthers(unique);
    }

    const handleContactsChange = (event, newValue) => {
        setSelectedContacts(newValue)
    }

    useEffect(() => {
        (async()=>{
        try {
            const result = await httpRequest({
                endPoint: `${backendHosts.WHATSAPP}${apiUrl.template}`,
                method: "get",
                instance: "instanceOne",
            })

            if(result?.status == 200){
                const data = result?.data.map(ele => {
                    return { label: ele }
                })
                setTemplate(data)
            }else{
                setErr(true)
                setErrMsg({msg : "An error occured while fetching templates" , color : "#F74542"})
            }

            
        } catch (e) {
            console.log(e , "erorr")
            setErr(true)
            setErrMsg({msg : "Error Occured" , color : "#F74542"})
        }

        try {
            const result = await httpRequest({
                endPoint: `${backendHosts.ADMIN_REPORT}${apiUrl.whatsappListCount}`,
                method: "get",
                instance: "instanceOne",
            })

            if(result?.status == 200){
                setContacts(result?.count)
            }else{
                setErr(true)
                setErrMsg({msg : "An error occured while fetching contact groups" , color : "#F74542"})
            }

        } catch (e) {
            console.log(e , "erorr")
            setErr(true)
            setErrMsg({msg : "Error Occured" , color : "#F74542"})
        }
    })()
    }, [])

    useEffect(()=>{
        setOthers([])
    },[selectedContacts])


    return (
        <Grid
            sx={{ margin: "7% 0 0 2%" }}
        >
            <Grid>
                <Typography
                    className={classes.campaignText}
                >WhatsApp Service</Typography>
            </Grid>
            {!testing && <Grid className={classes.grid1} >

                <Autocomplete
                    disablePortal
                    loading
                    value={selectedTemplate}
                    options={template}
                    onChange={handleTemplateChange}
                    sx={{ width: 300, background: "#131E2E", color: "white", height: "54px" }}
                    renderInput={(params) => <TextField
                        {...params}
                        label="Select template"
                        InputLabelProps={{
                            style: { color: 'white' }
                        }}
                        sx={{
                            '& .MuiInputBase-root': {
                                color: 'white',
                            },
                        }}
                    />}
                />

<Grid >
          {topStocks && <Button
                component="label"
                className={classes.chooseButton}
                variant="contained"
                tabIndex={-1}
                startIcon={<FileOpenIcon />}
              >
                Choose file
                <VisuallyHiddenInput
                  type="file"
                  onChange={(e) => {
                    getData(e);
                  }}
                  ref={(input) => {
                    if (input) {
                      // Reset the input after the file is selected to allow re-upload of the same file
                      input.value = null;
                    }
                  }}
                />
            </Button>}
            {fileName && topStocks && <Typography className={classes.info} sx={{width : "200px" , wordWrap : "wrap"}} >{fileName}</Typography>}
        </Grid >

                <Grid>
                    <TextField
                        value={mobile}
                        onChange={handleMobileChange}
                        variant="outlined"
                        type='tel'
                        disabled={!selectedTemplate}
                        label="Enter Phone"
                        InputLabelProps={{
                            style: {
                                color: "#FFFFFF"
                            }
                        }}
                        onClick={() => {
                            if (!selectedTemplate) {
                                alert("Please select a template")
                            }
                        }}
                        onInput={(e) => {
                            let value = e.target.value.replace(/[^0-9]/g, '');
                            if (value.length > 10) {
                                value = value.slice(0, 10);
                            }
                            e.target.value = value;
                        }}
                        InputProps={{
                            style: {
                                color: "#FFFFFF",
                                width: '400px !important',
                                backgroundColor: '#0B1420',
                                flexShrink: 0,
                                height: "55px",
                                fontFamily: 'cardiuma-regular !important',
                                fontSize: '12px !important',
                                fontStyle: 'normal',
                                fontWeight: '400 !important',
                                lineHeight: '20px',
                                caretColor: 'white',
                                paddingTop: '0px',
                            },
                            inputProps: {
                                autoComplete: 'off',
                                inputMode: 'numeric',
                            },
                        }}
                        autoComplete="off"
                    />
                    {!selectedTemplate && <Typography className={classes.info} >Please Select a template</Typography>}
                    {selectedTemplate && mobile?.length !== 10 && <Typography className={classes.info} >Enter 10 digit Mobile No.</Typography>}
                </Grid>

                <Button sx={{
                    '&:disabled': {
                        backgroundColor: 'grey !important',
                    }
                }} disabled={((mobile.length !== 10) || !selectedTemplate) || (!fileName && topStocks)} className={classes.button} onClick={handleTesting} >Test template</Button>
            </Grid>}
            {testing && <Typography className={classes.info1} > Testing Success <br /> Template Name : - {selectedTemplate?.label} <br /> <Button onClick={handleReset} size='small' className={classes.reTest} >Re - Test</Button> </Typography>}

            {testing && <Grid className={classes.grid1} sx={{ justifyContent: "start !important" }} >

                <Autocomplete
                    value={selectedContacts}
                    disablePortal
                    disabled={!testing}
                    onChange={handleContactsChange}
                    options={contactsList}
                    sx={{ width: 300, background: "#131E2E", color: "white" }}
                    renderInput={(params) => <TextField
                        {...params}
                        label="Select contacts"
                        InputLabelProps={{
                            style: { color: 'white' }
                        }}
                        sx={{
                            '& .MuiInputBase-root': {
                                color: 'white',
                            },
                        }}
                    />}
                />

                <Button sx={{
                    '&:disabled': {
                        backgroundColor: 'grey !important',
                    }
                }} disabled={!selectedContacts || (selectedContacts?.label == "Franchisee" && others.length === 0) || (selectedContacts?.label == "state" && others.length === 0) } className={classes.button} onClick={() => {
                    handleSend()
                }} >Send</Button>
            </Grid>}

            {testing && (selectedContacts?.label == "Franchisee" || selectedContacts?.label == "state") && <Autocomplete
                loading
                multiple
                disableCloseOnSelect
                value={others}
                onChange={handleOthersChange}
                sx={{
                    marginTop: "20px",
                    width: 300,
                    background: "#131E2E",
                    color: "white",
                    '& .MuiAutocomplete-option': {
                        color: 'white !important',
                        backgroundColor: '#1A2D42',
                        '&:hover': {
                            backgroundColor: '#2A3A4C',
                        },
                    },
                    '& .MuiAutocomplete-clearIndicator': {
                        color: 'white',
                        '&:hover': {
                            color: '#FF0000',
                        },
                    },
                    '& .MuiChip-root': {
                        backgroundColor: '#1A2D42',
                        color: 'white',
                        '& .MuiChip-deleteIcon': {
                            color: 'white',
                        },
                    },
                }}
                id="tags-standard"
                options={ selectedContacts?.label == "Franchisee" ? franchiseeList : StateList}
                getOptionLabel={(option) => option.label}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={ selectedContacts?.label == "Franchisee" ? "Select Franchisee" : "Select State"}
                        InputLabelProps={{
                            style: { color: 'white' },
                        }}
                        sx={{
                            '& .MuiInputBase-root': {
                                color: 'white',
                            },
                        }}
                    />
                )}
            />

            }

            <Snackbar
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right"
                }}
                open={err}
                autoHideDuration={3000}
                onClose={() =>{ 
                    setErrMsg({msg : "" , color : ""})
                    setErr(false)}}
            >
                <SnackbarContent
                style={{
                    backgroundColor: errMsg?.color,  // Background color (e.g., red for error)
                    borderRadius: "4px",  // Optional, to add rounded corners
                }}
                    message={
                        <span style={{
                            display: "flex",
                            alignItems: "center",
                            color: "#ffffff",
                            fontSize: "12px",
                            fontFamily: "cardiuma-regular"
                        }}>
                            {errMsg?.msg}
                        </span>
                    }
                />
            </Snackbar>


            <Dialog
                open={dialog}
                onClose={() => {
                    setDialog(false)
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {dialogContent?.title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {dialogContent?.body}
                        {loading &&
                            <Grid sx={{ display: "flex", justifyContent: "center" }}>
                                <CircularProgress size={40} />
                            </Grid>}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialog(false)} >Cancel</Button>
                    <Button disabled={loading || (testing && loading)} onClick={() => {
                        if (testing) {
                            handleSubmit("send")
                        } else {
                            handleSubmit("test")
                        }
                    }} >
                        Send
                    </Button>
                </DialogActions>
            </Dialog>

        </Grid>
    )
}

export default withStyles(styles)(WhatsApp)